import React, {useEffect, useState} from 'react';
import '../scss/components/Profile.scss';
import ProfileTabs from '../components/Profile/ProfileTabs.tsx';
import { IProfile } from '../interface/IProfile.ts';
import { useProfileApi } from '../features/auth/hooks/use-profile-api.ts';
import { useParams } from 'react-router-dom';
import { ApiResponseType } from '../features/api/types.ts';
import ApiCheck from '../components/Structure/ApiCheck.tsx';

export default function Profile() {
    const [profile, setProfile] = useState<IProfile|any>({});
    const [profileIsLoading, setProfileIsLoading] = useState(true);
    const { getProfile } = useProfileApi();
    const [apiErrors, setApiErrors] = useState<any>();
    const { active, addition } = useParams();
    useEffect(() => {
        getProfile().then(data => {
            if (data.type === ApiResponseType.OK) {
                setProfile(data.payload);
            } else {
                setApiErrors(data.payload);
            }
            setProfile(data.payload);
            setProfileIsLoading(false);
        })
    },[]);
    if (profileIsLoading) {
        return (<div className="loader"></div>);
    }
    return (
        <div id="profile">
            <ApiCheck errors={apiErrors ? apiErrors.errors : null}>
                <h1 className="h3">Profilinformationen</h1>
                <ProfileTabs profile={profile} setProfile={setProfile} active={active} addition={addition}/>
            </ApiCheck>
        </div>
    )
}